import { createSlice } from '@reduxjs/toolkit'
import { DataList } from '../common'
import {
  fetchSettings,
  createSetting,
  showSetting,
  modifySetting,
  createSettingDetail,
  modifySettingDetail,
  deleteSettingDetail,
  deleteSetting,
  copySetting,
  exportSetting,
  createArticleRulesGroup,
  updateArticleRulesGroup,
  deleteArticleRulesGroup,
  updateArticleRulesPageSetting
} from './settingAPI'
import type { Setting, SettingState } from './types'
import {
  selectIdReducer,
  unselectIdReducer,
  clearSelectedIdsReducer,
  openModalReducer,
  closeModalReducer,
  selectTabReducer,
  closeAlertReducer,
  dismissErrorReducer,
  buildExtraReducers
} from './settingReducer'

const initialState: SettingState = {
  sort: { column: 'id', order: 'desc' },
  setting: null,
  selectedIds: [],
  openedModal: null,
  currentTab: 'columnSetting',
  ...DataList.initialState,
  data: [] as Setting[],
  errors: {},
  alert: { show: false, title: null, alertBody: null }
}

export const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    selectColumn: DataList.selectColumn,
    selectPage: DataList.selectPage,
    selectId: selectIdReducer,
    unselectId: unselectIdReducer,
    clearSelectedIds: clearSelectedIdsReducer,
    openModal: openModalReducer,
    closeModal: closeModalReducer,
    selectTab: selectTabReducer,
    closeAlert: closeAlertReducer,
    dismissError: dismissErrorReducer
  },
  extraReducers: (builder) =>
    buildExtraReducers(builder, {
      fetchSettings,
      createSetting,
      showSetting,
      modifySetting,
      deleteSetting,
      copySetting,
      exportSetting,
      createSettingDetail,
      modifySettingDetail,
      deleteSettingDetail,
      createArticleRulesGroup,
      updateArticleRulesGroup,
      deleteArticleRulesGroup,
      updateArticleRulesPageSetting
    })
})

export const {
  selectColumn,
  selectPage,
  selectId,
  unselectId,
  clearSelectedIds,
  openModal,
  closeModal,
  selectTab,
  dismissError
} = settingSlice.actions
